export const moduleName = 'location';
